export default "/images/add.svg?3ed4fef99a487a2ef467608ed5454cca";